import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeFourComponent} from './home-4/home-four.component';
import {ProductLeftSidebarComponent} from './product/product-details/product-left-sidebar/product-left-sidebar.component';
import {CartComponent} from './product/cart/cart.component';
import {CheckoutComponent} from './product/checkout/checkout.component';
import {SuccessComponent} from './product/success/success.component';
import {SearchComponent} from './home-4/search/search.component';


// Routes
const routes: Routes = [
  {
    path: '',
    component: HomeFourComponent
  },
  {
    path: 'search/:article',
    component: SearchComponent
  },
  {
    path: 'articlesDepartment/:departmentId',
    component: HomeFourComponent
  },
  {
    path: 'left-sidebar/product/:id',
    component: ProductLeftSidebarComponent
  },
  {
    path: 'cart',
    component: CartComponent
  },
  {
    path: 'checkout',
    component: CheckoutComponent
  },
  {
    path: 'checkout/success/:id',
    component: SuccessComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShopRoutingModule { }
